// extracted by mini-css-extract-plugin
export default {"countLabel":"CommentsCount_countLabel__Z8mjq"};